import type { TOrganizationProjectDimension } from "@/zapi-frontend/shared/types/projects";

export type TPortfolioViewMode = "table" | "cards";

export type TPortfolioSortDir = "asc" | "desc";

export type TSystemColumn = "version" | "creator" | "modified" | "modifiedBy" | "status";

export type TPortfolioSortField =
  | "none"
  | "lastModified"
  | "name"
  | "createdBy"
  | "modifiedBy"
  | "status"
  | { kind: "dimension"; dimensionId: string };

export type TPortfolioPrefs = {
  viewMode: TPortfolioViewMode;
  hiddenDimensionIds: string[];
  hiddenSystemColumns: TSystemColumn[];
  sortFieldKey: string;
  sortDir: TPortfolioSortDir;
  savedFilters: Record<string, string[]>;
};

export type TActiveFilters = Record<string, Set<string>>;

export function filtersFromSaved(saved: Record<string, string[]>): TActiveFilters {
  const out: TActiveFilters = {};
  for (const [k, arr] of Object.entries(saved)) {
    if (arr.length > 0) out[k] = new Set(arr);
  }
  return out;
}

export function savedFromFilters(filters: TActiveFilters): Record<string, string[]> {
  const out: Record<string, string[]> = {};
  for (const [k, set] of Object.entries(filters)) {
    if (set.size > 0) out[k] = [...set];
  }
  return out;
}

export function sortFieldToKey(f: TPortfolioSortField): string {
  if (typeof f === "string") return f;
  return `dim:${f.dimensionId}`;
}

export function sortKeyToField(key: string, dimensions: TOrganizationProjectDimension[]): TPortfolioSortField {
  if (key.startsWith("dim:")) {
    const id = key.slice(4);
    if (dimensions.some((d) => String(d.id) === id)) return { kind: "dimension", dimensionId: id };
  }
  if (key === "none" || key === "name" || key === "createdBy" || key === "modifiedBy" || key === "lastModified" || key === "status") return key;
  return "none";
}
